module.exports = __webpack_public_path__ + "static/img/kehu.31fa804.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/kehu.png
// module id = WrB1
// module chunks = 1